import { render, staticRenderFns } from "./salesDetail.vue?vue&type=template&id=5cd0f4b4&scoped=true"
import script from "./salesDetail.vue?vue&type=script&lang=js"
export * from "./salesDetail.vue?vue&type=script&lang=js"
import style0 from "./salesDetail.vue?vue&type=style&index=0&id=5cd0f4b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd0f4b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd0f4b4')) {
      api.createRecord('5cd0f4b4', component.options)
    } else {
      api.reload('5cd0f4b4', component.options)
    }
    module.hot.accept("./salesDetail.vue?vue&type=template&id=5cd0f4b4&scoped=true", function () {
      api.rerender('5cd0f4b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auditcenter/salesDetail.vue"
export default component.exports